var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menus_nav_colorful",
      style: { "--theme-color": _vm.themeColor },
    },
    [
      _c(
        "div",
        { ref: "leftAside", staticClass: "left-aside" },
        _vm._l(_vm.menusList, function (item, index) {
          return _c(
            "div",
            {
              key: index + "_" + item.id,
              class: ["f-item", index === _vm.currentIndex && "active"],
              on: {
                click: function ($event) {
                  return _vm.changeMenu(index)
                },
              },
            },
            [_c("span", { staticClass: "f-text" }, [_vm._v(_vm._s(item.name))])]
          )
        }),
        0
      ),
      _c(
        "div",
        {
          ref: "rightAside",
          staticClass: "right-aside",
          on: { scroll: _vm.handleScroll },
        },
        [
          _vm._l(_vm.menusList, function (group, index) {
            return _c(
              "div",
              {
                key: "group_" + index,
                ref: "group_" + index,
                refInFor: true,
                class: ["group", index === _vm.currentIndex && "active-group"],
              },
              [
                _c("div", { staticClass: "group-title" }, [
                  _c("span", { staticClass: "title-text" }, [
                    _vm._v(_vm._s(group.name)),
                  ]),
                  _vm.hasAllChild(group)
                    ? _c("span", { staticClass: "more" }, [
                        _vm._v(" 查看更多 "),
                        _c("i", { staticClass: "more-arrow" }),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "t-list" },
                  _vm._l(group.childrens || [], function (child) {
                    return _c(
                      "div",
                      { key: child.id, staticClass: "t-item" },
                      [
                        _c("el-image", {
                          staticClass: "img-icon",
                          attrs: { src: child.icon },
                        }),
                        _c("div", { staticClass: "child-name" }, [
                          _vm._v(_vm._s(child.name)),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            )
          }),
          !_vm.menusList.length
            ? _c("div", { staticClass: "empty" }, [_vm._v("请先配置菜单")])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }